import { useParams } from "react-router-dom";
import { useFetchFrontendSubCategoriesQuery } from "../../stores/api/pages.api";
import { UserLayout } from "./components/layout/UserLayout";
import PageHero from "./components/PageHero";
import Container from "./components/Container";
import Text from "./components/Text";
import { ROUTE_PATHS } from "../../constants/routeConstants";

const Skeleton = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

const CategoryDetailSkeleton = () => (
  <UserLayout>
    <Container variant="narrow" className="py-10 px-4 lg:px-8">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {[...Array(8)].map((_, i) => (
          <Skeleton key={i} className="h-16" />
        ))}
      </div>
    </Container>
  </UserLayout>
);

const CategoryDetail = () => {
  const { categorySlug } = useParams();
  const { data: subCategories, isLoading } = useFetchFrontendSubCategoriesQuery(categorySlug);

  if (isLoading) return <CategoryDetailSkeleton />;

  const category = subCategories?.[0]?.category;
  const categoryName = category?.name ?? categorySlug;

  return (
    <UserLayout>
      <PageHero
        title={categoryName}
        crumbs={[
          { label: "Home", href: ROUTE_PATHS.HOME },
          { label: "Products", href: ROUTE_PATHS.PRODUCTS },
          { label: categoryName },
        ]}
      />

      <Container variant="narrow" className="py-10 px-4 lg:px-8">
        <Container
          variant="full"
          showEmptyState={!subCategories?.length}
          emptyMessage="No subcategories found for this category."
        >
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {(subCategories ?? []).map((sub) => (
              <Text
                key={sub.slug}
                is="a"
                href={`${ROUTE_PATHS.PRODUCTS}?sub_category_slug=${sub.slug}`}
                className="flex items-center justify-center border border-gray-200 rounded-lg px-4 py-5 text-sm font-medium text-gray-700 hover:border-gray-900 hover:text-gray-900 transition-colors text-center"
              >
                {sub.name}
              </Text>
            ))}
          </div>
        </Container>
      </Container>
    </UserLayout>
  );
};

export default CategoryDetail;
